import axios from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const fetchHistory = async () => {
  const response = await axios.get(`${API_BACKEND_URL}/history`);
  return response.data;
};

export const useFetchHistory = (options = {}) => {
  return useQuery({
    queryKey: ["apiRunHistory"],
    queryFn: fetchHistory,
    ...options,
  });
};

const fetchHistoryByCollection = async ({ name }) => {
  const user = getUserDetails();
  const response = await axios.get(
    `${API_BACKEND_URL}/history/getHistoryByCollection?companyId=${user.companyid}&name=${name}`,
  );
  return response.data;
};

export const useFetchHistoryByCollection = (options = {}, name) => {
  return useQuery({
    queryKey: ["historyByCollection", name],
    queryFn: () => fetchHistoryByCollection({ name }),
    ...options,
  });
};

const deleteHistoryEntry = async ({ historyId }) => {
  const user = getUserDetails();

  const response = await axios.delete(
    `${API_BACKEND_URL}/history/deleteHistory?companyId=${user.companyid}&historyId=${historyId}`,
  );

  return response.data;
};

export const useDeleteHistoryEntry = (options = {}) => {
  return useMutation({
    mutationFn: deleteHistoryEntry,
    ...options,
  });
};

const clearHistory = async () => {
  const user = getUserDetails();

  const response = await axios.delete(
    `${API_BACKEND_URL}/history/deleteAllHistory?companyId=${user.companyid}`,
  );

  return response.data;
};

export const useClearHistory = (options = {}) => {
  return useMutation({
    mutationFn: clearHistory,
    ...options,
  });
};
